import { useSelectionContext } from 'modules/customEvents/contexts';
import { groupSelectStatus } from 'modules/customEvents/utils';
import { FieldTableColumns } from 'modules/dataDictionary/types';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { GroupSelect } from 'ui/indexPages/tables/groupSelect';
import { HelpTooltip } from 'ui/tooltip';
import { Cell } from './Cell';

type Props = {
  columns: FieldTableColumns[];
  fieldIds: string[];
  gridLayout: string;
};

export const TableHeader = ({ columns, fieldIds, gridLayout }: Props) => {
  const { selected, selectByIds, deselectAll } = useSelectionContext();

  const checkboxStatus = groupSelectStatus(selected.length, fieldIds.length);

  const onSelectAll = () => {
    selectByIds(fieldIds);
  };

  return (
    <HeaderGridRow gridLayout={gridLayout}>
      {Object.values(columns).map((col) => {
        if (col.id === 'bulkAction') {
          return (
            <Cell key={col.id}>
              <GroupSelect
                onSelectAll={onSelectAll}
                onSelectNone={deselectAll}
                status={checkboxStatus}
              />
            </Cell>
          );
        }
        return (
          <Cell data-justify={col?.justify} key={col.id}>
            <span>{col.label}</span>
            {col?.tooltipContent && (
              <HelpTooltip
                iconProps={{ height: 16, width: 16 }}
                isEnabled={!!col.tooltipContent}
                tooltipContent={col?.tooltipContent}
              />
            )}
          </Cell>
        );
      })}
    </HeaderGridRow>
  );
};
